import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

export const Store2Icon: FunctionComponent<IIconProps> = ({ ...props }) => (
  <Icon {...{ viewBox: '0 0 16 16', ...props }}>
    <Path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.333}
      d="M10 14v-3.333A.667.667 0 0 0 9.333 10H6.667a.667.667 0 0 0-.667.667V14m5.85-7.127a.747.747 0 0 0-1.033 0 1.667 1.667 0 0 1-2.301 0 .747.747 0 0 0-1.032 0 1.667 1.667 0 0 1-2.301 0 .747.747 0 0 0-1.033 0 1.667 1.667 0 0 1-2.513-2.165l1.926-2.79a1.333 1.333 0 0 1 1.104-.585h6.666a1.334 1.334 0 0 1 1.102.582l1.93 2.795a1.667 1.667 0 0 1-2.516 2.163M2.667 7.3v5.367A1.333 1.333 0 0 0 4 14h8a1.333 1.333 0 0 0 1.333-1.333V7.3"
    />
  </Icon>
)
